<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <!-- Enhanced Header Section -->
      <div class="page-header modern-header" style="background-color: #255EFF;">
        <div class="header-content">
          <div class="page-title-section">
            <div class="title-wrapper">
              <div class="icon-wrapper">
                <i class="fas fa-chart-line text-primary"></i>
              </div>
              <div class="title-content">
                <h4 class="page-title">Dashboard</h4>
                <p class="page-subtitle">Vue d'ensemble de vos contrats et activités</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Statistics Cards -->
      <div class="row mb-4">
        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12 mb-3">
          <div class="card stat-card domiciliation-card">
            <div class="card-body">
              <div class="stat-content">
                <div class="stat-icon">
                  <i class="fas fa-building"></i>
                </div>
                <div class="stat-details">
                  <h3 class="stat-number" :title="stats.domiciliations.total.toLocaleString()">
                    {{ formatLargeNumber(stats.domiciliations.total) }}
                  </h3>
                  <p class="stat-label">Domiciliations</p>
                  <div class="stat-trend">
                    <span class="trend-indicator positive" v-if="stats.domiciliations.trend > 0">
                      <i class="fas fa-arrow-up"></i>
                      <span class="trend-text">+{{ formatTrendNumber(stats.domiciliations.trend) }}%</span>
                    </span>
                    <span class="trend-indicator negative" v-else-if="stats.domiciliations.trend < 0">
                      <i class="fas fa-arrow-down"></i>
                      <span class="trend-text">{{ formatTrendNumber(stats.domiciliations.trend) }}%</span>
                    </span>
                    <span class="trend-indicator neutral" v-else>
                      <i class="fas fa-minus"></i>
                      <span class="trend-text">0%</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12 mb-3">
          <div class="card stat-card bureau-card">
            <div class="card-body">
              <div class="stat-content">
                <div class="stat-icon">
                  <i class="fas fa-users"></i>
                </div>
                <div class="stat-details">
                  <h3 class="stat-number" :title="stats.bureaux.total.toLocaleString()">
                    {{ formatLargeNumber(stats.bureaux.total) }}
                  </h3>
                  <p class="stat-label">Bureaux Équipe</p>
                  <div class="stat-trend">
                    <span class="trend-indicator positive" v-if="stats.bureaux.trend > 0">
                      <i class="fas fa-arrow-up"></i>
                      <span class="trend-text">+{{ formatTrendNumber(stats.bureaux.trend) }}%</span>
                    </span>
                    <span class="trend-indicator negative" v-else-if="stats.bureaux.trend < 0">
                      <i class="fas fa-arrow-down"></i>
                      <span class="trend-text">{{ formatTrendNumber(stats.bureaux.trend) }}%</span>
                    </span>
                    <span class="trend-indicator neutral" v-else>
                      <i class="fas fa-minus"></i>
                      <span class="trend-text">0%</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12 mb-3">
          <div class="card stat-card revenue-card">
            <div class="card-body">
              <div class="stat-content">
                <div class="stat-icon">
                  <i class="fas fa-money-bill-wave"></i>
                </div>
                <div class="stat-details">
                  <h3 class="stat-number" :title="formatMontant(stats.revenue.total)">
                    {{ formatLargeRevenue(stats.revenue.total) }}
                  </h3>
                  <p class="stat-label">Chiffre d'Affaires</p>
                  <div class="stat-trend">
                    <span class="trend-indicator positive" v-if="stats.revenue.trend > 0">
                      <i class="fas fa-arrow-up"></i>
                      <span class="trend-text">+{{ formatTrendNumber(stats.revenue.trend) }}%</span>
                    </span>
                    <span class="trend-indicator negative" v-else-if="stats.revenue.trend < 0">
                      <i class="fas fa-arrow-down"></i>
                      <span class="trend-text">{{ formatTrendNumber(stats.revenue.trend) }}%</span>
                    </span>
                    <span class="trend-indicator neutral" v-else>
                      <i class="fas fa-minus"></i>
                      <span class="trend-text">0%</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12 mb-3">
          <div class="card stat-card clients-card">
            <div class="card-body">
              <div class="stat-content">
                <div class="stat-icon">
                  <i class="fas fa-user-tie"></i>
                </div>
                <div class="stat-details">
                  <h3 class="stat-number" :title="stats.clients.total.toLocaleString()">
                    {{ formatLargeNumber(stats.clients.total) }}
                  </h3>
                  <p class="stat-label">Clients Actifs</p>
                  <div class="stat-trend">
                    <span class="trend-indicator positive" v-if="stats.clients.trend > 0">
                      <i class="fas fa-arrow-up"></i>
                      <span class="trend-text">+{{ formatTrendNumber(stats.clients.trend) }}%</span>
                    </span>
                    <span class="trend-indicator negative" v-else-if="stats.clients.trend < 0">
                      <i class="fas fa-arrow-down"></i>
                      <span class="trend-text">{{ formatTrendNumber(stats.clients.trend) }}%</span>
                    </span>
                    <span class="trend-indicator neutral" v-else>
                      <i class="fas fa-minus"></i>
                      <span class="trend-text">0%</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Charts Row -->
      <div class="row mb-4">
        <div class="col-xl-8 col-12">
          <div class="card chart-card">
            <div class="card-header d-flex align-items-center justify-content-between flex-wrap gap-2">
              <h5 class="card-title mb-0">
                <i class="fas fa-chart-area me-2"></i>
                Évolution des Contrats
              </h5>
              <div class="d-flex align-items-center gap-2 chart-pagination-controls">
                <button class="btn btn-sm btn-light" :disabled="chartPage === 1" @click="goToChartPage(1)">
                  <i class="fas fa-angle-double-left"></i>
                </button>
                <button class="btn btn-sm btn-light" :disabled="chartPage === 1" @click="goToChartPage(chartPage - 1)">
                  <i class="fas fa-angle-left"></i>
                </button>
                <span class="small text-muted">
                  Page {{ chartPage }} / {{ chartTotalPages }}
                </span>
                <button class="btn btn-sm btn-light" :disabled="chartPage === chartTotalPages"
                  @click="goToChartPage(chartPage + 1)">
                  <i class="fas fa-angle-right"></i>
                </button>
                <button class="btn btn-sm btn-light" :disabled="chartPage === chartTotalPages"
                  @click="goToChartPage(chartTotalPages)">
                  <i class="fas fa-angle-double-right"></i>
                </button>
              </div>
            </div>
            <div class="card-body">
              <canvas ref="contractsChart" height="300"></canvas>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-12">
          <div class="text-start py-4">
            <div
              v-if="chartData.time_remaining && (chartData.time_remaining.days > 0 || chartData.time_remaining.hours > 0 || chartData.time_remaining.minutes > 0 || chartData.time_remaining.seconds > 0) && chartData.time_remaining.date_fin">
              <!-- Header with animated clock -->
              <div class="mb-4 d-flex align-items-center">
                <svg class="me-2" width="32" height="32" viewBox="0 0 24 24" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="#dc3545" stroke-width="2" fill="none" />
                  <circle cx="12" cy="12" r="1" fill="#dc3545" />
                  <line x1="12" y1="12" x2="12" y2="8" stroke="#dc3545" stroke-width="2" stroke-linecap="round">
                    <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="43200s"
                      repeatCount="indefinite" />
                  </line>
                  <line x1="12" y1="12" x2="12" y2="6" stroke="#dc3545" stroke-width="1.5" stroke-linecap="round">
                    <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="3600s"
                      repeatCount="indefinite" />
                  </line>
                  <line x1="12" y1="12" x2="12" y2="4" stroke="#ff6b6b" stroke-width="1" stroke-linecap="round">
                    <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="60s"
                      repeatCount="indefinite" />
                  </line>
                  <line x1="12" y1="2" x2="12" y2="4" stroke="#dc3545" stroke-width="2" />
                  <line x1="12" y1="20" x2="12" y2="22" stroke="#dc3545" stroke-width="2" />
                  <line x1="2" y1="12" x2="4" y2="12" stroke="#dc3545" stroke-width="2" />
                  <line x1="20" y1="12" x2="22" y2="12" stroke="#dc3545" stroke-width="2" />
                </svg>
                <div>
                  <h5 class="text-danger fw-bold mb-1">Abonnement</h5>
                  <span v-if="chartData.time_remaining.type" class="badge bg-primary fs-6 px-3 py-2">
                    <i class="fas fa-tag me-1"></i>
                    {{ chartData.time_remaining.type }}
                  </span>
                </div>
              </div>
              <!-- Main countdown display -->
              <p class="fw-semibold text-muted mb-0">Jours restants :</p>
              <div class="fw-semibold display-5 text-danger mb-2">
                {{ chartData.time_remaining.days }} jour(s)
              </div>
              <!-- Date range -->
              <div class="text-muted fs-6 mt-3">
                <span v-if="chartData.time_remaining.date_debut">
                  <i class="fas fa-calendar-plus me-1 text-success"></i>
                  Début: {{ formatDate(chartData.time_remaining.date_debut) }}
                </span>
                <span v-if="chartData.time_remaining.date_debut && chartData.time_remaining.date_fin"
                  class="mx-2">|</span>
                <span>
                  <i class="fas fa-calendar-times me-1 text-danger"></i>
                  Fin: {{ formatDate(chartData.time_remaining.date_fin) }}
                </span>
              </div>
            </div>
            <!-- No data state -->
            <div v-else class="text-start py-4">
              <svg class="mb-3" width="48" height="48" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="#6c757d" stroke-width="2" fill="none" />
                <line x1="12" y1="8" x2="12" y2="12" stroke="#6c757d" stroke-width="2" stroke-linecap="round" />
                <line x1="12" y1="16" x2="12.01" y2="16" stroke="#6c757d" stroke-width="2" stroke-linecap="round" />
              </svg>
              <div class="text-muted">
                <h6 class="mb-1">Aucune donnée d'abonnement</h6>
                <small>Veuillez vérifier votre statut</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Contracts Expiring Soon -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="card alert-card">
            <div class="card-header">
              <h5 class="card-title">
                <i class="fas fa-exclamation-triangle me-2"></i>
                Contrats Arrivant à Échéance
              </h5>
              <div class="alert-filters">
                <select v-model="expirationFilter" @change="filterExpiringContracts" class="form-select form-select-sm">
                  <option value="5">≤ 5 jours</option>
                  <option value="15">≤ 15 jours</option>
                  <option value="30">≤ 30 jours</option>
                </select>
              </div>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>Référence</th>
                      <th>Client</th>
                      <th>Type</th>
                      <th>Date Fin</th>
                      <th>Jours Restants</th>
                      <th>Montant</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="contract in expiringContracts" :key="contract.id"
                      :class="getExpirationRowClass(contract.days_remaining)">
                      <td>
                        <span class="reference-badge">{{ contract.reference_numero }}</span>
                      </td>
                      <td>{{ contract.client_nom }}</td>
                      <td>
                        <span :class="getContractTypeBadge(contract.type)">
                          {{ contract.type === 'domiciliation' ? 'Domiciliation' : 'Bureau Équipe' }}
                        </span>
                      </td>
                      <td>{{ formatDate(contract.date_fin) }}</td>
                      <td>
                        <span :class="getExpirationBadge(contract.days_remaining)">
                          {{ contract.days_remaining }} jour(s)
                        </span>
                      </td>
                      <td>{{ formatMontant(contract.montant) }}</td>
                      <td>
                        <div class="action-buttons">
                          <button class="btn btn-sm btn-primary" @click="renewContract(contract)">
                            <i class="fas fa-sync-alt"></i> Renouveler
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Recent Activities -->
      <div class="row mb-4">
        <div class="col-xl-6 col-12">
          <div class="card activity-card">
            <div class="card-header">
              <h5 class="card-title">
                <i class="fas fa-history me-2"></i>
                Activités Récentes
              </h5>
            </div>
            <div class="card-body">
              <div class="activity-timeline">
                <div v-for="activity in recentActivities" :key="activity.id" class="activity-item">
                  <div class="activity-icon" :class="getActivityIconClass(activity.type)">
                    <i :class="getActivityIcon(activity.type)"></i>
                  </div>
                  <div class="activity-content">
                    <div class="activity-title">{{ activity.title }}</div>
                    <div class="activity-description">{{ activity.description }}</div>
                    <div class="activity-time">{{ formatDateTime(activity.created_at) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-12">
          <div class="card clients-card-detailed">
            <div class="card-header d-flex align-items-center justify-content-between flex-wrap gap-2">
              <h5 class="card-title mb-0">
                <i class="fas fa-users me-2"></i>
                Évolution des Clients
              </h5>
              <div class="d-flex flex-wrap gap-2 align-items-center clients-controls">
                <div class="input-chip">
                  <span class="chip-label">Plage</span>
                  <select class="form-select form-select-sm chip-select" v-model="clientsRange" @change="updateCharts">
                    <option value="all">Tout</option>
                    <option value="year">12 derniers mois</option>
                    <option value="six">6 derniers mois</option>
                  </select>
                </div>
                <div class="input-chip">
                  <span class="chip-label">Granularité</span>
                  <select class="form-select form-select-sm chip-select" v-model="clientsGranularity" @change="updateCharts">
                    <option value="auto">Auto</option>
                    <option value="daily">Journalier</option>
                    <option value="monthly">Mensuel</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="card-body clients-card-body">
              <div class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                <div>
                  <p class="text-muted mb-1 small">Variation sur la période sélectionnée</p>
                  <h5 class="mb-0">
                    <span class="badge rounded-pill"
                      :class="clientsSummary.trendingUp ? 'bg-success-soft text-success' : 'bg-danger-soft text-danger'">
                      <i :class="clientsSummary.trendingUp ? 'fas fa-arrow-up' : 'fas fa-arrow-down'"></i>
                      {{ clientsSummary.changeLabel }}
                    </span>
                    <span class="ms-2 text-muted small">({{ clientsSummary.percentLabel }})</span>
                  </h5>
                </div>
                <div class="text-end">
                  <p class="text-muted mb-1 small">Total affiché</p>
                  <h4 class="mb-0 fw-bold text-primary">{{ clientsSummary.latest }}</h4>
                </div>
              </div>
              <div class="clients-chart-wrapper">
                <canvas ref="clientsChart" height="280"></canvas>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Quick Actions -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="card quick-actions-card">
            <div class="card-header">
              <h5 class="card-title">
                <i class="fas fa-bolt me-2"></i>
                Actions Rapides
              </h5>
            </div>
            <div class="card-body">
              <div class="quick-actions-grid">
                <div class="quick-action-item" @click="navigateTo('/domiciliations')">
                  <div class="quick-action-icon domiciliation">
                    <i class="fas fa-building"></i>
                  </div>
                  <div class="quick-action-content">
                    <h6>Nouvelle Domiciliation</h6>
                    <p>Créer un nouveau contrat de domiciliation</p>
                  </div>
                </div>
                <div class="quick-action-item" @click="navigateTo('/bureaux-equipe')">
                  <div class="quick-action-icon bureau">
                    <i class="fas fa-users"></i>
                  </div>
                  <div class="quick-action-content">
                    <h6>Nouveau Bureau Équipe</h6>
                    <p>Créer un nouveau contrat de bureau équipe</p>
                  </div>
                </div>
                <div class="quick-action-item" @click="navigateTo('/addclient')">
                  <div class="quick-action-icon client">
                    <i class="fas fa-user-plus"></i>
                  </div>
                  <div class="quick-action-content">
                    <h6>Nouveau Client</h6>
                    <p>Ajouter un nouveau client</p>
                  </div>
                </div>
                <div class="quick-action-item" @click="generateReport()">
                  <div class="quick-action-icon report">
                    <i class="fas fa-file-alt"></i>
                  </div>
                  <div class="quick-action-content">
                    <h6>Générer Rapport</h6>
                    <p>Créer un rapport personnalisé</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";
import { markRaw, toRaw } from 'vue';
import Chart from 'chart.js/auto';

export default {
  name: 'DashboardView',
  data() {
    return {
      isRefreshing: false,
      chartPeriod: '30',
      chartPage: 1,
      chartPageSize: 12,
      clientsRange: 'all',
      clientsGranularity: 'auto',
      expirationFilter: '15',
      // Statistics
      stats: {
        domiciliations: { total: 0, trend: 0 },
        bureaux: { total: 0, trend: 0 },
        revenue: { total: 0, trend: 0 },
        clients: { total: 0, trend: 0 }
      },
      // Charts
      contractsChart: null,
      clientsChart: null,
      // Data
      expiringContracts: [],
      recentActivities: [],
      companyInfo: null,
      // Chart data - Initialisation avec des valeurs par défaut
      chartData: {
        contracts: {
          labels: [],
          domiciliations: [],
          bureaux: []
        },
        clients: {
          labels: [],
          data: []
        },
        time_remaining: {
          date_debut: null,
          date_fin: null,
          type: 'N/A',
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        }
      }
    };
  },
  computed: {
    chartTotalPages() {
      const labels = (this.chartData.contracts && this.chartData.contracts.labels) || [];
      const total = Math.ceil(labels.length / this.chartPageSize) || 1;
      return total;
    },
    visibleContractsData() {
      const contracts = this.chartData.contracts || { labels: [], domiciliations: [], bureaux: [] };
      const labels = contracts.labels || [];
      const domiciliationData = contracts.domiciliations || [];
      const bureauxData = contracts.bureaux || [];

      const totalPages = this.chartTotalPages;
      const safePage = Math.min(Math.max(this.chartPage, 1), totalPages);
      const start = (safePage - 1) * this.chartPageSize;
      const end = start + this.chartPageSize;

      return {
        labels: labels.slice(start, end),
        domiciliations: domiciliationData.slice(start, end),
        bureaux: bureauxData.slice(start, end)
      };
    },
    visibleClientsData() {
      const clients = this.chartData.clients || { labels: [], data: [] };
      const labels = [...(toRaw(clients.labels) || [])];
      const dataPoints = [...(toRaw(clients.data) || [])];

      if (!labels.length) return { labels: [], data: [] };

      const parsed = labels.map((label, idx) => {
        const date = new Date(label);
        const validDate = !isNaN(date.getTime());
        const monthKey = validDate
          ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`
          : `idx-${idx}`;
        const dayKey = validDate
          ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
          : `idx-${idx}`;
        return {
          rawLabel: label,
          monthKey,
          dayKey,
          order: validDate ? date.getTime() : idx,
          value: dataPoints[idx] || 0
        };
      });

      const aggregateByMonth = () => {
        const map = new Map();
        parsed.forEach((item) => {
          const existing = map.get(item.monthKey);
          if (existing) {
            existing.value += item.value;
            existing.order = Math.max(existing.order, item.order);
          } else {
            map.set(item.monthKey, { value: item.value, order: item.order });
          }
        });
        return Array.from(map.entries())
          .sort((a, b) => a[1].order - b[1].order)
          .map(([key, info]) => ({
            label: this.formatMonthLabel(key),
            value: info.value,
            order: info.order
          }));
      };

      const aggregateByDay = () => {
        const map = new Map();
        parsed.forEach((item) => {
          const existing = map.get(item.dayKey);
          if (existing) {
            existing.value += item.value;
            existing.order = Math.max(existing.order, item.order);
          } else {
            map.set(item.dayKey, { value: item.value, order: item.order, raw: item.rawLabel });
          }
        });
        return Array.from(map.entries())
          .sort((a, b) => a[1].order - b[1].order)
          .map(([key, info]) => ({
            label: this.formatDayLabel(key, info.raw),
            value: info.value,
            order: info.order
          }));
      };

      // Decide mode based on selection and dataset length
      if (this.clientsRange === 'all') {
        if (this.clientsGranularity === 'daily') {
          const daily = aggregateByDay();
          return { labels: daily.map(i => i.label), data: daily.map(i => i.value) };
        }

        if (this.clientsGranularity === 'monthly') {
          const aggregatedAll = aggregateByMonth();
          return { labels: aggregatedAll.map(i => i.label), data: aggregatedAll.map(i => i.value) };
        }

        const shouldAggregate = parsed.length > 45;
        if (!shouldAggregate) return { labels, data: dataPoints };

        const aggregatedAll = aggregateByMonth();
        return { labels: aggregatedAll.map(i => i.label), data: aggregatedAll.map(i => i.value) };
      }

      // Aggregated month slices for year / six months
      const aggregated = aggregateByMonth();
      const sliceCount = this.clientsRange === 'year' ? 12 : 6;
      const sliced = aggregated.slice(-sliceCount);

      return {
        labels: sliced.map((item) => item.label),
        data: sliced.map((item) => item.value)
      };
    },
    clientsSummary() {
      const visible = this.visibleClientsData;
      const values = visible.data || [];
      const latest = values.length ? values[values.length - 1] : 0;
      const prev = values.length > 1 ? values[values.length - 2] : 0;
      const change = latest - prev;
      const percent = prev ? (change / prev) * 100 : (latest ? 100 : 0);
      const sign = change >= 0 ? '+' : '';
      const percentSign = percent >= 0 ? '+' : '';

      return {
        latest,
        change,
        percent,
        changeLabel: `${sign}${change}`,
        percentLabel: `${percentSign}${percent.toFixed(1)}%`,
        trendingUp: change >= 0
      };
    }
  },
  watch: {
    chartPage() {
      this.updateCharts();
    },
    clientsRange() {
      this.updateCharts();
    }
  },
  methods: {
    // Enhanced number formatting methods
    formatLargeNumber(number) {
      if (typeof number !== 'number' || isNaN(number)) return '0';
      const absNumber = Math.abs(number);
      if (absNumber >= 1000000000) {
        return (number / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B';
      } else if (absNumber >= 1000000) {
        return (number / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
      } else if (absNumber >= 1000) {
        return (number / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
      } else {
        return number.toLocaleString('fr-FR');
      }
    },

    formatLargeRevenue(amount) {
      if (typeof amount !== 'number' || isNaN(amount)) return '0 MAD';
      const absAmount = Math.abs(amount);
      if (absAmount >= 1000000000) {
        return (amount / 1000000000).toFixed(1).replace(/\.0$/, '') + 'B MAD';
      } else if (absAmount >= 1000000) {
        return (amount / 1000000).toFixed(1).replace(/\.0$/, '') + 'M MAD';
      } else if (absAmount >= 1000) {
        return (amount / 1000).toFixed(1).replace(/\.0$/, '') + 'K MAD';
      } else {
        return new Intl.NumberFormat("fr-FR", {
          style: "currency",
          currency: "MAD",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(amount);
      }
    },

    formatTrendNumber(trend) {
      if (typeof trend !== 'number' || isNaN(trend)) return '0';
      const absTrend = Math.abs(trend);
      if (absTrend >= 1000) {
        return (trend / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
      } else if (absTrend >= 100) {
        return Math.round(trend).toString();
      } else {
        return trend.toFixed(1).replace(/\.0$/, '');
      }
    },

    // ==================== Chart Pagination ====================
    goToChartPage(page) {
      const target = Math.min(Math.max(Number(page) || 1, 1), this.chartTotalPages);
      this.chartPage = target;
    },

    setClientsRange(range) {
      this.clientsRange = range;
    },

    formatMonthLabel(key) {
      const date = new Date(`${key}-01`);
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString('fr-FR', { month: 'short', year: 'numeric' });
      }
      return key;
    },

    formatDayLabel(key, fallback) {
      const date = new Date(key);
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString('fr-FR', { month: 'short', day: 'numeric' });
      }
      return fallback || key;
    },

    startCountdown() {
      setInterval(() => {
        const end = new Date(this.chartData.time_remaining.date_fin).getTime();
        const now = new Date().getTime();
        let diff = Math.max(0, end - now);
        this.chartData.time_remaining.days = Math.floor(diff / (1000 * 60 * 60 * 24));
        this.chartData.time_remaining.hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        this.chartData.time_remaining.minutes = Math.floor((diff / (1000 * 60)) % 60);
        this.chartData.time_remaining.seconds = Math.floor((diff / 1000) % 60);
      }, 1000);
    },

    // ==================== API Configuration ====================
    getApiHeaders() {
      const token = localStorage.getItem("access_token");
      return {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "application/json",
      };
    },

    // ==================== Data Fetching ====================
    async fetchDashboardData() {
      this.isRefreshing = true;
      try {
        await Promise.all([
          this.fetchStats(),
          this.fetchExpiringContracts(),
          this.fetchRecentActivities(),
          this.fetchChartData(),
          this.fetchCompanyInfo()
        ]);
      } catch (error) {
        console.error("Erreur lors du chargement du dashboard:", error);
        this.showErrorMessage("Erreur lors du chargement des données");
      } finally {
        this.isRefreshing = false;
      }
    },

    async fetchStats() {
      try {
        const response = await axios.get("/dashboard/stats", {
          headers: this.getApiHeaders(),
        });
        this.stats = response.data;
      } catch (error) {
        console.error("Erreur stats:", error);
        // Données de fallback
        this.stats = {
          domiciliations: { total: 45, trend: 12 },
          bureaux: { total: 23, trend: 8 },
          revenue: { total: 125000, trend: 15 },
          clients: { total: 68, trend: 5 }
        };
      }
    },

    async fetchExpiringContracts() {
      try {
        const response = await axios.get(`/dashboard/expiring-contracts?days=${this.expirationFilter}`, {
          headers: this.getApiHeaders(),
        });
        //console.log("Contrats expirants:", response.data);
        this.expiringContracts = response.data;
      } catch (error) {
        if (error.response && error.response.status === 401) {
          Swal.fire({
            icon: 'error',
            title: 'Session expirée',
            text: 'Vous allez être déconnecté.',
            timer: 2000,
            showConfirmButton: false
          }).then(() => {
            this.$router.push({ name: "logout" });
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erreur',
            text: 'Une erreur est survenue lors de la récupération des contrats expirants.',
            timer: 2000,
            showConfirmButton: false
          })
        }
      }
    },

    async fetchRecentActivities() {
      try {
        const response = await axios.get("/dashboard/recent-activities", {
          headers: this.getApiHeaders(),
        });
        this.recentActivities = response.data;
      } catch (error) {
        if (error.response && error.response.status === 401) {
          Swal.fire({
            icon: 'error',
            title: 'Session expirée',
            text: 'Vous allez être déconnecté.',
            timer: 2000,
            showConfirmButton: false
          }).then(() => {
            this.$router.push({ name: "logout" });
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erreur',
            text: 'Une erreur est survenue lors de la récupération des activités récentes.',
            timer: 2000,
            showConfirmButton: false
          })
        }
      }
    },

    async fetchChartData() {
      try {
        const response = await axios.get(`/dashboard/chart-data?period=${this.chartPeriod}`, {
          headers: this.getApiHeaders(),
        });
        // Vérifier que la réponse contient les données attendues
        if (response.data) {
          this.chartData = {
            contracts: response.data.contracts || this.chartData.contracts,
            time_remaining: response.data.remaining_days_subscription || this.chartData.time_remaining,
            clients: response.data.clients || this.chartData.clients
          };
          this.chartPage = 1;
        }
        // Mettre à jour les graphiques seulement si les données sont valides
        this.updateCharts();
      } catch (error) {
        if (error.response && error.response.status === 401) {
          Swal.fire({
            icon: 'error',
            title: 'Session expirée',
            text: 'Vous allez être déconnecté.',
            timer: 2000,
            showConfirmButton: false
          }).then(() => {
            this.$router.push({ name: "logout" });
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erreur',
            text: 'Une erreur est survenue lors de la récupération des données du graphique.',
            timer: 2000,
            showConfirmButton: false
          })
        }
        this.generateFallbackChartData();
        this.updateCharts();
      }
    },

    async fetchCompanyInfo() {
      try {
        const response = await axios.get('/societes');
        if (response.data) {
          this.companyInfo = {
            nom: response.data.nom_francais,
            adresse: response.data.adresse_siege_social_francais,
            telephone: response.data.telephone,
            email: response.data.email,
            logo: response.data.logo || response.data.logo_path,
            rc: response.data.rc,
            identifiant_fiscal: response.data.identifiant_fiscal,
            tp: response.data.tp,
            ice: response.data.ice
          };
        }
      } catch (err) {
        this.companyInfo = null;
        if (err && err.response && err.response.status === 401) {
          Swal.fire({
            icon: 'error',
            title: 'Session expirée',
            text: 'Vous allez être déconnecté.',
            timer: 2000,
            showConfirmButton: false
          }).then(() => {
            this.$router.push({ name: "logout" });
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erreur',
            text: 'Une erreur est survenue lors du chargement des informations de la société.',
            timer: 2000,
            showConfirmButton: false
          })
        }
      }
    },

    generateFallbackChartData() {
      const days = parseInt(this.chartPeriod);
      const labels = [];
      const domiciliations = [];
      const bureaux = [];
      const clients = [];

      for (let i = days - 1; i >= 0; i--) {
        const date = new Date();
        date.setDate(date.getDate() - i);
        if (days <= 30) {
          labels.push(date.toLocaleDateString('fr-FR', { month: 'short', day: 'numeric' }));
        } else {
          labels.push(date.toLocaleDateString('fr-FR', { month: 'short', year: '2-digit' }));
        }
        domiciliations.push(Math.floor(Math.random() * 10) + 1);
        bureaux.push(Math.floor(Math.random() * 8) + 1);
        clients.push(Math.floor(Math.random() * 15) + 5);
      }

      this.chartData = {
        contracts: { labels, domiciliations, bureaux },
        clients: { labels, data: clients },
        time_remaining: {
          date_debut: null,
          date_fin: null,
          type: 'N/A',
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        }
      };
      this.chartPage = 1;
    },

    // ==================== Chart Management ====================
    initializeCharts() {
      this.$nextTick(() => {
        if (!this.chartData.clients || !this.chartData.clients.labels) {
          this.generateFallbackChartData();
          return;
        }
        this.createContractsChart();
        this.createClientsChart();
      });
    },

    createContractsChart() {
      const canvas = this.$refs.contractsChart;
      const ctx = canvas ? canvas.getContext('2d') : null;
      if (!ctx) return;

      if (this.contractsChart) {
        this.contractsChart.destroy();
      }

      const contractsData = this.visibleContractsData;
      const labels = [...(toRaw(contractsData.labels) || [])];
      const domiciliationData = [...(toRaw(contractsData.domiciliations) || [])];
      const bureauxData = [...(toRaw(contractsData.bureaux) || [])];

      const domGradient = ctx.createLinearGradient(0, 0, 0, 320);
      domGradient.addColorStop(0, 'rgba(37, 94, 255, 0.25)');
      domGradient.addColorStop(1, 'rgba(37, 94, 255, 0.65)');

      const bureGradient = ctx.createLinearGradient(0, 0, 0, 320);
      bureGradient.addColorStop(0, 'rgba(248, 155, 79, 0.3)');
      bureGradient.addColorStop(1, 'rgba(248, 155, 79, 0.75)');

      const totals = labels.map((_, idx) => (domiciliationData[idx] || 0) + (bureauxData[idx] || 0));

      this.contractsChart = markRaw(new Chart(ctx, {
        type: 'bar',
        data: {
          labels,
          datasets: [
            {
              label: 'Domiciliations',
              data: domiciliationData,
              backgroundColor: domGradient,
              borderColor: '#255EFF',
              borderWidth: 2,
              borderRadius: 12,
              maxBarThickness: 32
            },
            {
              label: 'Bureaux Équipe',
              data: bureauxData,
              backgroundColor: bureGradient,
              borderColor: '#f89b4f',
              borderWidth: 2,
              borderRadius: 12,
              maxBarThickness: 32
            },
            {
              type: 'line',
              label: 'Total',
              data: totals,
              borderColor: '#0a2d4c',
              backgroundColor: 'rgba(10, 45, 76, 0.08)',
              borderWidth: 3,
              tension: 0.35,
              fill: true,
              pointBackgroundColor: '#0a2d4c',
              pointBorderColor: '#fff',
              pointBorderWidth: 2,
              pointRadius: 5
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'top',
              labels: {
                boxWidth: 14,
                usePointStyle: true
              }
            },
            tooltip: {
              backgroundColor: '#0a2d4c',
              titleColor: '#fff',
              bodyColor: '#fff',
              callbacks: {
                label: (ctx) => {
                  const label = ctx.dataset.label || '';
                  const value = ctx.raw == null ? 0 : ctx.raw;
                  return `${label}: ${value}`;
                }
              }
            }
          },
          scales: {
            x: {
              grid: {
                display: false
              },
              ticks: {
                maxRotation: 0,
                minRotation: 0
              }
            },
            y: {
              beginAtZero: true,
              grid: {
                color: 'rgba(0,0,0,0.05)'
              },
              ticks: {
                precision: 0
              }
            }
          }
        }
      }));
    },

    createClientsChart() {
      const canvas = this.$refs.clientsChart;
      const ctx = canvas ? canvas.getContext('2d') : null;
      if (!ctx) return;

      if (this.clientsChart) {
        this.clientsChart.destroy();
      }

      const clientsData = this.visibleClientsData;
      const labels = [...(toRaw(clientsData.labels) || [])];
      const dataPoints = [...(toRaw(clientsData.data) || [])];

      const lineGradient = ctx.createLinearGradient(0, 0, 0, 260);
      lineGradient.addColorStop(0, 'rgba(79, 172, 254, 0.4)');
      lineGradient.addColorStop(1, 'rgba(79, 172, 254, 0.05)');

      this.clientsChart = markRaw(new Chart(ctx, {
        type: 'line',
        data: {
          labels,
          datasets: [{
            label: 'Nouveaux Clients',
            data: dataPoints,
            borderColor: '#4facfe',
            backgroundColor: lineGradient,
            tension: 0.35,
            fill: true,
            pointBackgroundColor: '#4facfe',
            pointBorderColor: '#fff',
            pointBorderWidth: 2,
            pointRadius: 5,
            pointHoverRadius: 7
          }]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              backgroundColor: '#0a2d4c',
              titleColor: '#fff',
              bodyColor: '#fff'
            }
          },
          scales: {
            x: {
              grid: {
                display: false
              },
              ticks: {
                maxRotation: 0,
                minRotation: 0,
                autoSkip: false,
                callback: function(value, index, ticks) {
                  const total = ticks.length || 1;
                  const step = Math.max(1, Math.floor(total / 6));
                  if (index === 0 || index === total - 1 || index % step === 0) {
                    return this.getLabelForValue ? this.getLabelForValue(value) : ticks[index].label;
                  }
                  return '';
                }
              }
            },
            y: {
              beginAtZero: true,
              grid: {
                color: 'rgba(0,0,0,0.05)'
              },
              ticks: {
                precision: 0,
                stepSize: 1
              }
            }
          }
        }
      }));
    },

    updateCharts() {
      if (this.contractsChart && this.chartData.contracts) {
        const visibleData = this.visibleContractsData;
        const labels = [...(toRaw(visibleData.labels) || [])];
        const domiciliationData = [...(toRaw(visibleData.domiciliations) || [])];
        const bureauxData = [...(toRaw(visibleData.bureaux) || [])];
        const totals = labels.map((_, idx) => (domiciliationData[idx] || 0) + (bureauxData[idx] || 0));

        this.contractsChart.data.labels = labels;
        this.contractsChart.data.datasets[0].data = domiciliationData;
        this.contractsChart.data.datasets[1].data = bureauxData;
        if (this.contractsChart.data.datasets[2]) {
          this.contractsChart.data.datasets[2].data = totals;
        }
        this.contractsChart.update();
      }

      if (this.clientsChart && this.chartData.clients) {
        const visibleClients = this.visibleClientsData;
        const labels = [...(toRaw(visibleClients.labels) || [])];
        const dataPoints = [...(toRaw(visibleClients.data) || [])];
        this.clientsChart.data.labels = labels;
        this.clientsChart.data.datasets[0].data = dataPoints;
        const ticks = this.clientsChart.options.scales.x.ticks;
        ticks.callback = function(value, index, tickArr) {
          const total = tickArr.length || 1;
          const step = Math.max(1, Math.floor(total / 6));
          if (index === 0 || index === total - 1 || index % step === 0) {
            return this.getLabelForValue ? this.getLabelForValue(value) : tickArr[index].label;
          }
          return '';
        };
        this.clientsChart.update();
      }
    },

    async updateChartData() {
      await this.fetchChartData();
    },

    // ==================== Event Handlers ====================
    async refreshDashboard() {
      await this.fetchDashboardData();
      this.showSuccessMessage("Données actualisées avec succès");
    },

    async filterExpiringContracts() {
      await this.fetchExpiringContracts();
    },

    renewContract(contract) {
      const route = contract.type === 'domiciliation' ? '/domiciliations' : '/admin/bureaux-equipe/BurreauEquipe';
      this.$router.push(route);
    },

    viewContract(contract) {
      const route = contract.type === 'domiciliation' ? '/domiciliations' : '/admin/bureaux-equipe/BurreauEquipe';
      this.$router.push(route);
    },

    navigateTo(route) {
      this.$router.push(route);
    },

    generateReport() {
      this.exportDashboardToPDF();
    },

    // ==================== Utility Methods ====================
    formatDate(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleDateString("fr-FR");
    },

    formatDateTime(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);
      return date.toLocaleString("fr-FR");
    },

    formatMontant(montant) {
      return new Intl.NumberFormat("fr-FR", {
        style: "currency",
        currency: "MAD",
      }).format(montant);
    },

    getExpirationRowClass(days) {
      if (days <= 0) return 'table-danger';
      if (days <= 5) return 'table-warning';
      if (days <= 15) return 'table-info';
      return '';
    },

    getExpirationBadge(days) {
      if (days <= 0) return 'badge bg-danger';
      if (days <= 5) return 'badge bg-warning text-dark';
      if (days <= 15) return 'badge bg-info';
      return 'badge bg-success';
    },

    getContractTypeBadge(type) {
      return type === 'domiciliation' ? 'badge bg-primary' : 'badge bg-secondary';
    },

    getActivityIconClass(type) {
      const classes = {
        creation: 'activity-icon-success',
        renewal: 'activity-icon-info',
        payment: 'activity-icon-warning',
        termination: 'activity-icon-danger'
      };
      return classes[type] || 'activity-icon-secondary';
    },

    getActivityIcon(type) {
      const icons = {
        creation: 'fas fa-plus',
        renewal: 'fas fa-sync-alt',
        payment: 'fas fa-money-bill',
        termination: 'fas fa-times'
      };
      return icons[type] || 'fas fa-info';
    },

    // ==================== Export Methods ====================
    exportDashboardToPDF() {
      const printWindow = window.open('', '_blank');
      const pdfContent = this.generateDashboardHTML();
      printWindow.document.open();
      printWindow.document.write(pdfContent);
      printWindow.document.close();
      printWindow.document.title = "Rapport Dashboard";
      printWindow.focus();
    },

    generateDashboardHTML() {
      const currentDate = new Date();
      const formattedDate = currentDate.toLocaleDateString('fr-FR');
      const formattedTime = currentDate.toLocaleTimeString('fr-FR');

      return `<!DOCTYPE html>
<html>
  <head>
    <title>Rapport Dashboard</title>
    <meta charset="UTF-8">
    <style>
      body { font-family: Arial, sans-serif; margin: 20px; font-size: 12px; }
      .header { display: flex; align-items: center; margin-bottom: 30px; border-bottom: 1px solid #ddd; padding-bottom: 15px; }
      .title { font-size: 18px; font-weight: bold; margin-bottom: 5px; }
      .stats-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px; margin-bottom: 30px; }
      .stat-card { border: 1px solid #ddd; padding: 15px; text-align: center; }
      .stat-number { font-size: 24px; font-weight: bold; margin-bottom: 5px; }
      .stat-label { color: #666; }
      table { width: 100%; border-collapse: collapse; margin-top: 20px; }
      th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
      th { background-color: #f5f5f5; }
      .no-print { margin-top: 30px; text-align: center; }
      .print-btn { background-color: #007bff; color: white; border: none; padding: 10px 20px; margin: 0 5px;  cursor: pointer; }
      @media print { .no-print { display: none; } }
    </style>
  </head>
  <body>
    <div class="header">
      <div>
        <div class="title">Rapport Dashboard</div>
        <div>Généré le ${formattedDate} à ${formattedTime}</div>
      </div>
    </div>
    
    <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-number">${this.stats.domiciliations.total}</div>
        <div class="stat-label">Domiciliations</div>
      </div>
      <div class="stat-card">
        <div class="stat-number">${this.stats.bureaux.total}</div>
        <div class="stat-label">Bureaux Équipe</div>
      </div>
      <div class="stat-card">
        <div class="stat-number">${this.formatMontant(this.stats.revenue.total)}</div>
        <div class="stat-label">Chiffre d'Affaires</div>
      </div>
      <div class="stat-card">
        <div class="stat-number">${this.stats.clients.total}</div>
        <div class="stat-label">Clients Actifs</div>
      </div>
    </div>

    <h3>Contrats Arrivant à Échéance</h3>
    <table>
      <thead>
        <tr>
          <th>Référence</th>
          <th>Client</th>
          <th>Type</th>
          <th>Date Fin</th>
          <th>Jours Restants</th>
          <th>Montant</th>
        </tr>
      </thead>
      <tbody>
        ${this.expiringContracts.length > 0 ?
          this.expiringContracts.map(contract => `
        <tr>
          <td>${contract.reference_numero}</td>
          <td>${contract.client_nom}</td>
          <td>${contract.type === 'domiciliation' ? 'Domiciliation' : 'Bureau Équipe'}</td>
          <td>${this.formatDate(contract.date_fin)}</td>
          <td>${contract.days_remaining} jour(s)</td>
          <td>${this.formatMontant(contract.montant)}</td>
        </tr>
      `).join('') :
          `<tr><td colspan="6" style="text-align:center;">Aucune donnée</td></tr>`
        }
      </tbody>
    </table>
    
    <div class="no-print">
      <button onclick="window.print()" class="print-btn">Imprimer</button>
      <button onclick="window.close()" class="print-btn">Fermer</button>
    </div>
  </body>
</html>`;
    },

    exportDashboardToExcel() {
      const dashboardData = [
        ['Statistiques Dashboard', '', '', ''],
        ['Type', 'Total', 'Tendance (%)', ''],
        ['Domiciliations', this.stats.domiciliations.total, this.stats.domiciliations.trend, ''],
        ['Bureaux Équipe', this.stats.bureaux.total, this.stats.bureaux.trend, ''],
        ['Chiffre d\'Affaires', this.stats.revenue.total, this.stats.revenue.trend, ''],
        ['Clients Actifs', this.stats.clients.total, this.stats.clients.trend, ''],
        ['', '', '', ''],
        ['Contrats Arrivant à Échéance', '', '', ''],
        ['Référence', 'Client', 'Type', 'Jours Restants'],
        ...this.expiringContracts.map(contract => [
          contract.reference_numero,
          contract.client_nom,
          contract.type === 'domiciliation' ? 'Domiciliation' : 'Bureau Équipe',
          contract.days_remaining
        ])
      ];

      const worksheet = XLSX.utils.aoa_to_sheet(dashboardData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Dashboard");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(data, `dashboard_${new Date().toISOString().split("T")[0]}.xlsx`);
    },

    // ==================== Success/Error Messages ====================
    showSuccessMessage(message) {
      Swal.fire({
        icon: "success",
        title: "Succès!",
        text: message,
        timer: 3000,
        showConfirmButton: false,
        position: "top-end",
        toast: true,
      });
    },

    showErrorMessage(message) {
      Swal.fire({
        icon: "error",
        title: "Erreur!",
        text: message,
        confirmButtonText: "OK",
      });
    },
  },

  async mounted() {
    try {
      // Set component as not ready initially
      this.isComponentReady = false;

      // Generate fallback data first
      this.generateFallbackChartData();

      // Start countdown
      this.startCountdown();

      // Wait for DOM to be fully ready
      await this.$nextTick();
      await new Promise(resolve => setTimeout(resolve, 100));

      // Mark component as ready
      this.isComponentReady = true;

      // Load real data
      await this.fetchDashboardData();

      // Wait a bit more for any reactive updates
      await this.$nextTick();
      await new Promise(resolve => setTimeout(resolve, 200));

      // Initialize charts only after everything is ready
      if (this.isComponentReady && !this.chartInitialized) {
        this.initializeCharts();
        this.chartInitialized = true;
      }

    } catch (error) {
      console.error('Error during dashboard initialization:', error);
      this.showErrorMessage('Erreur lors de l\'initialisation du dashboard');
    }
  },

  beforeUnmount() {
    if (this.contractsChart) this.contractsChart.destroy();
    if (this.clientsChart) this.clientsChart.destroy();
  }
};
</script>

<style scoped>
/* ==================== Modern Header ==================== */
.modern-header {
  background: #255EFF !important;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  color: white;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.page-title-section {
  display: flex;
  align-items: center;
  gap: 2rem;
  flex: 1;
}

.title-wrapper {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.icon-wrapper {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
}

.title-content h4 {
  margin: 0;
  font-size: 1.8rem;
  font-weight: 700;
  color: white;
}

.page-subtitle {
  margin: 0.25rem 0 0 0;
  opacity: 0.9;
  font-size: 0.95rem;
}

/* ==================== Statistics Cards ==================== */
.stat-card {
  border: none;
  border-radius: 0px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  overflow: hidden;
  height: 100%;
  min-height: 130px;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.stat-card .card-body {
  padding: 1.25rem;
  height: 100%;
  display: flex;
  align-items: center;
}

.stat-content {
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  min-width: 0;
}

.stat-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  color: white;
  flex-shrink: 0;
}

.domiciliation-card .stat-icon {
  background: linear-gradient(135deg, #255EFF, #325697);
}

.bureau-card .stat-icon {
  background: linear-gradient(135deg, #2fe4dc, #3889c8);
}

.revenue-card .stat-icon {
  background: linear-gradient(135deg, #24853b, #3edf7c);
}

.clients-card .stat-icon {
  background: linear-gradient(135deg, #6a55c1, #392a45);
}

.stat-details {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.stat-number {
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 0.2rem;
  color: #2c3e50;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stat-label {
  font-size: 0.75rem;
  color: #6c757d;
  font-weight: 500;
  margin-bottom: 0.4rem;
  line-height: 1.3;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.stat-trend {
  display: flex;
  align-items: center;
}

.trend-indicator {
  font-size: 0.65rem;
  font-weight: 600;
  padding: 0.2rem 0.4rem;
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  max-width: 100%;
  overflow: hidden;
}

.trend-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trend-indicator.positive {
  background: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.trend-indicator.negative {
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.trend-indicator.neutral {
  background: rgba(108, 117, 125, 0.1);
  color: #6c757d;
}

/* ==================== Chart Cards ==================== */
.chart-card {
  border-radius: 0px;
  border: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 1.5rem;
}

.chart-card .card-header {
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 1.25rem 1.5rem;
  border-radius: 0px;
}

/* ==================== Alert Card ==================== */
.alert-card {
  border: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border-left: 4px solid #ffc107;
  border-radius: 0px;
}

.alert-card .card-header {
  background: linear-gradient(135deg, #fff3cd, #ffeaa7);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  padding: 1.25rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0px;
}

.reference-badge {
  background: #255EFF;
  color: white;
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
  font-weight: 600;
}

.action-buttons {
  display: flex;
  gap: 0.5rem;
}

/* ==================== Activity Card ==================== */
.activity-card {
  border-radius: 0px;
  border: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.activity-timeline {
  max-height: 400px;
  overflow-y: auto;
}

.activity-item {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  padding: 1rem 0;
  border-bottom: 1px solid #f1f3f4;
}

.activity-item:last-child {
  border-bottom: none;
}

.activity-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 0.875rem;
  flex-shrink: 0;
}

.activity-icon-success {
  background: #28a745;
}

.activity-icon-info {
  background: #17a2b8;
}

.activity-icon-warning {
  background: #ffc107;
}

.activity-icon-danger {
  background: #dc3545;
}

.activity-icon-secondary {
  background: #6c757d;
}

.activity-content {
  flex: 1;
}

.activity-title {
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.25rem;
}

.activity-description {
  color: #6c757d;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
}

.activity-time {
  color: #adb5bd;
  font-size: 0.75rem;
}

/* ==================== Clients Card ==================== */
.clients-card-detailed {
  border: none;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  background: linear-gradient(145deg, #f7f9ff 0%, #eef3ff 100%);
}

.clients-card-detailed .card-header {
  border-bottom: 0;
  background: transparent;
}

.clients-card-detailed .card-title {
  font-weight: 700;
  color: #255EFF;
}

.clients-card-body {
  background: #ffffff;
  border-radius: 16px;
  padding: 1.25rem;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.clients-chart-wrapper {
  position: relative;
  height: 280px;
}

.clients-view-toggle .btn {
  border-color: #d9e2ff;
  color: #255EFF;
}

.clients-view-toggle .btn.active {
  background: #255EFF;
  color: #fff;
}

.bg-success-soft {
  background: rgba(25, 135, 84, 0.12) !important;
}

.bg-danger-soft {
  background: rgba(220, 53, 69, 0.12) !important;
}

.clients-controls .input-chip {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  background: #f6f8ff;
  border: 1px solid #dfe7ff;
  border-radius: 999px;
  padding: 0.25rem 0.6rem;
  box-shadow: 0 4px 12px rgba(37, 94, 255, 0.08);
}

.clients-controls .chip-label {
  font-size: 0.8rem;
  font-weight: 600;
  color: #255EFF;
  white-space: nowrap;
}

.chip-select {
  border: none;
  background: transparent;
  padding: 0.25rem 0.1rem;
  font-weight: 600;
  color: #0a2d4c;
  min-width: 140px;
}

.chip-select:focus {
  box-shadow: none;
  background: transparent;
}

/* ==================== Quick Actions ==================== */
.quick-actions-card {
  border: none;
  border-radius: 0px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.quick-actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.quick-action-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  border: 2px solid #f1f3f4;
  transition: all 0.3s ease;
  cursor: pointer;
}

.quick-action-item:hover {
  border-color: #255EFF;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(171, 194, 112, 0.2);
}

.quick-action-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.25rem;
}

.quick-action-icon.domiciliation {
  background: linear-gradient(135deg, #255EFF, #325697);
}

.quick-action-icon.bureau {
  background: linear-gradient(135deg, #667eea, #764ba2);
}

.quick-action-icon.client {
  background: linear-gradient(135deg, #4facfe, #00f2fe);
}

.quick-action-icon.report {
  background: linear-gradient(135deg, #f093fb, #f5576c);
}

.quick-action-content h6 {
  margin: 0 0 0.25rem 0;
  font-weight: 600;
  color: #2c3e50;
}

.quick-action-content p {
  margin: 0;
  color: #6c757d;
  font-size: 0.875rem;
}

/* ==================== Responsive Design ==================== */
@media (max-width: 768px) {
  .modern-header {
    padding: 1.5rem;
  }

  .stat-card {
    min-height: 110px;
  }

  .stat-content {
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
  }

  .stat-icon {
    width: 40px;
    height: 40px;
    font-size: 1.1rem;
    margin: 0 auto;
  }

  .stat-number {
    font-size: 1.2rem;
  }

  .stat-label {
    font-size: 0.7rem;
  }

  .trend-indicator {
    font-size: 0.6rem;
    justify-content: center;
  }
}

@media (max-width: 576px) {
  .modern-header {
    padding: 1rem;
  }

  .quick-actions-grid {
    grid-template-columns: 1fr;
  }

  .quick-action-item {
    flex-direction: column;
    text-align: center;
  }
}
</style>
